import { MuiTable } from "./MuiTable";
import { MuiButton } from "./MuiButton";
import { MuiTab } from "./MuiTab";
import { MuiTexField } from "./MuiTextField";
import { MuiDatePicker } from "./MuiCalendarPicker";
import { MuiCard } from "./MuiCard";

const overrides = {
  ...MuiTable,
  ...MuiButton,
  ...MuiTab,
  ...MuiTexField,
  ...MuiDatePicker,
  ...MuiCard,
};

export default overrides;
